module.exports = __webpack_public_path__ + "img/product-26.52708391.jpg";